import { Menu } from "../management/menu.model";

export class CartItem {
    id: string; // frontendonly
    menu: Menu;
    qty: number;
    sizeid: number;
    notes: string;
}